var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 9.353 8.45.002h5.137V4.358L2 9.353Z",
    fill: "#FF9D28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.586 4.358V22l6.417-20.002-6.417 2.36Z",
    fill: "#68C5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.587 9.357h-5.138l5.138 12.645V9.357Z",
    fill: "#044D80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2 9.353 9.767 3.246-1.318-3.245L2 9.353Z",
    fill: "#E54747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.bddb8f28dd74fb0ebf371fe9dc4310a8.svg";
export { ForwardRef as ReactComponent };